// Model Cache Configuration
// Simplified version that doesn't pre-fetch from CDN

export const setupModelCache = async () => {
  try {
    if ('caches' in window) {
      // Just ensure cache storage is available
      const cacheName = 'whisper-models-v1';
      const cache = await caches.open(cacheName);
      console.log('Model cache storage initialized');
    }
  } catch (err) {
    console.warn('Model cache setup warning:', err);
  }
};

// Initialize on app load
if (typeof window !== 'undefined') {
  setupModelCache().catch(err => console.warn('Cache init error:', err));
}
